__turbopack_context__.v({
  "accordionSlideOverwrite": "organization-contact-card-module-scss-module__pke-6q__accordionSlideOverwrite",
  "cardHeading": "organization-contact-card-module-scss-module__pke-6q__cardHeading",
  "contactAvatar": "organization-contact-card-module-scss-module__pke-6q__contactAvatar",
  "contactAvatarWrapper": "organization-contact-card-module-scss-module__pke-6q__contactAvatarWrapper",
  "contactCard": "organization-contact-card-module-scss-module__pke-6q__contactCard",
  "contactCardHeadingRow": "organization-contact-card-module-scss-module__pke-6q__contactCardHeadingRow",
  "contactChip": "organization-contact-card-module-scss-module__pke-6q__contactChip",
  "contactCopy": "organization-contact-card-module-scss-module__pke-6q__contactCopy",
  "contactDetails": "organization-contact-card-module-scss-module__pke-6q__contactDetails",
  "contactHeader": "organization-contact-card-module-scss-module__pke-6q__contactHeader",
  "contactHeaderEmail": "organization-contact-card-module-scss-module__pke-6q__contactHeaderEmail",
  "contactHeadingBlock": "organization-contact-card-module-scss-module__pke-6q__contactHeadingBlock",
  "contactItem": "organization-contact-card-module-scss-module__pke-6q__contactItem",
  "contactLabel": "organization-contact-card-module-scss-module__pke-6q__contactLabel",
  "contactLink": "organization-contact-card-module-scss-module__pke-6q__contactLink",
  "contactLinkWebsite": "organization-contact-card-module-scss-module__pke-6q__contactLinkWebsite",
  "contactName": "organization-contact-card-module-scss-module__pke-6q__contactName",
  "contactNameRow": "organization-contact-card-module-scss-module__pke-6q__contactNameRow",
  "contactValue": "organization-contact-card-module-scss-module__pke-6q__contactValue",
  "emptyState": "organization-contact-card-module-scss-module__pke-6q__emptyState",
  "fadeIn": "organization-contact-card-module-scss-module__pke-6q__fadeIn",
  "fadeOut": "organization-contact-card-module-scss-module__pke-6q__fadeOut",
  "scaleIn": "organization-contact-card-module-scss-module__pke-6q__scaleIn",
  "scaleOut": "organization-contact-card-module-scss-module__pke-6q__scaleOut",
  "zoomIn": "organization-contact-card-module-scss-module__pke-6q__zoomIn",
  "zoomOut": "organization-contact-card-module-scss-module__pke-6q__zoomOut",
});
